import React from "react";
import BotTemplateCollections from "@components/BotTemplateCollections";
import axios from "axios";

interface BotTemplateProps {
    data: any;
}

const BotTemplate: React.FC<BotTemplateProps> = (props) => {
    const { data } = props;
    return <BotTemplateCollections inputData={data} />;
};
// function BotTemplate({ data }) {
//     return <BotTemplateCollections inputData={data} />;
// }
export const getCategories = async (): Promise<string[]> => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiSecret = process.env.REACT_APP_API_SECRET;

    let categories: string[] = [];
    await axios({
        method: "get",
        url: "https://server.gallabox.com/devapi/bot-templates/categories",
        headers: {
            apiSecret: apiSecret,
            apiKey: apiKey,
        },
    })
        .then(function (response) {
            categories = JSON.parse(JSON.stringify(response?.data));
            // console.log("categories", categories);
        })
        .catch(function (err) {
            console.log("An error occured", err);
        });
    return categories;
};

export async function getServerSideProps(): Promise<{
    props: {
        data: {
            newData: string;
            res: undefined;
            slug: string[];
            categories: string[];
        };
    };
}> {
    // const slugVal = params.slug;
    let result;
    await axios({
        method: "get",
        url: "https://server.gallabox.com/devapi/bot-templates",
        headers: {
            apiSecret: process.env.REACT_APP_API_SECRET,
            apiKey: process.env.REACT_APP_API_KEY,
        },
        data: {
            status: "published",
            limit: 100,
            category: "",
        },
    })
        .then(function (response) {
            // result = response;
            // console.log("result", result);
            result = JSON.parse(JSON.stringify(response?.data));
        })
        .catch(function (err) {
            console.log(err);
        });

    const categoriesList = await getCategories();
    // console.log("categoriesList", categoriesList);

    return {
        props: {
            data: {
                newData: "hello",
                res: result,
                slug: ["all"],
                categories: categoriesList,
            },
        },
    };
}
export default BotTemplate;
